import React from "react";
import PropTypes from "prop-types";
import { DmsTextFieldMasked } from "dmsbasereact";

/**
 * Mask function for CEP (Brazilian postal code).
 *
 * Formats the input into the CEP pattern: XXXXX-XXX
 *
 * @param {string} value - The raw input value.
 * @returns {string} The masked CEP value.
 */
const CepMask = (value) => {
  value = value.replace(/\D/g, "");
  value = value.slice(0, 8);

  if (value.length <= 5) return value;
  return `${value.slice(0, 5)}-${value.slice(5, 8)}`;
};

/**
 * Text field component for CEP (Brazilian postal code) input with built-in mask.
 *
 * @param {Object} props - The component props.
 * @param {string} props.name - Input name.
 * @param {string} props.label - Input label.
 * @param {string} props.placeholder - Input placeholder.
 * @returns {JSX.Element} The rendered CEP input field.
 */
export const DmsTextFieldCep = ({
  name = "cep",
  label = "CEP",
  placeholder = "XXXXX-XXX",
  inputProps = {},
  ...props
}) => (
  <DmsTextFieldMasked
    name={name}
    label={label}
    placeholder={placeholder}
    inputProps={{ maxLength: 9, ...inputProps }}
    maskFunction={CepMask}
    {...props}
  />
);

DmsTextFieldCep.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  inputProps: PropTypes.object,
};
